import React, { useEffect, useState, useCallback } from "react";

import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";

// @YUp
import { Button, Grid } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Visibility from "@mui/icons-material/Visibility";
import API from "../../utils/Axios.utils";
import useAuth from "../../hooks/useAuth";

const ViewCandidate = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const candidateDetails = location.state?.CandidateDetails;

  const isDocFile = (val) => typeof val === 'string' && (val.includes('.') || val.includes('/') || val.includes('\\') || val.includes('http'));
  const [fileUrl, setFileUrl] = useState(candidateDetails?.url || "");
  const [panUrl, setPanUrl] = useState(candidateDetails?.s3Key_pan_doc || (candidateDetails?.pan_doc && isDocFile(candidateDetails.pan_doc) ? candidateDetails.pan_doc : ""));
  const [aadharUrl, setAadharUrl] = useState(candidateDetails?.s3Key_aadhar_doc || (candidateDetails?.aadhar_doc && isDocFile(candidateDetails.aadhar_doc) ? candidateDetails.aadhar_doc : ""));
  const isNonResume =
    candidateDetails?.pipeline_type === "non_resume_based" ||
    candidateDetails?.JobPost?.pipeline_type === "non_resume_based" ||
    candidateDetails?.Job?.pipeline_type === "non_resume_based" ||
    (!candidateDetails?.url &&
      !candidateDetails?.profile_path &&
      !candidateDetails?.resume_url);

  // Navigate directly to the candidate list page to avoid extra history entries
  const navigateToPreviousPage = () => {
    navigate("/candidate_data", { replace: true });
  };

  const { token, user: userDetails } = useAuth();

  const getPdfUrl = useCallback(async () => {
    if (!candidateDetails) return;
    try {
      const res = await API.post(
        '/api/profile/candidate_document',
        {
          supplierId: userDetails?.supplierId || candidateDetails?.supplier_id,
          coreSkillId: candidateDetails?.coreSkillId,
          job_code: candidateDetails?.job_code,
          email: candidateDetails?.email,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setFileUrl(res?.data?.url);
      setPanUrl(res?.data?.panUrl || "");
      setAadharUrl(res?.data?.aadharUrl || "");
    } catch (error) {
      console.error("Error fetching PDF URL:", error);
    }
  }, [token, userDetails?.supplierId, candidateDetails, isNonResume]);

  useEffect(() => {
    getPdfUrl();
  }, [getPdfUrl]);

  return (
    <div style={{ marginTop: 20 }}>
      <Button startIcon={<ArrowBackIcon />} onClick={navigateToPreviousPage} sx={{ mb: 2 }}>
        Back
      </Button>
        <div
          style={{
            border: "1px solid #989898",
            borderRadius: "10px",
            padding: "15px"
          }}
        >
          <span
            style={{
              fontSize: "20px",
              fontWeight: 550
            }}
          >
            View Profile
          </span>
          <div style={{ display: "grid" }}>
            <Grid container spacing={2}>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>Job Code</span>
                <div>{candidateDetails?.job_code || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>Candidate Name</span>
                <div>{candidateDetails?.candidate_name || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>Location</span>
                <div>{candidateDetails?.candidate_current_location || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>Mobile</span>
                <div>{candidateDetails?.mobile || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>Email</span>
                <div>{candidateDetails?.email || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>Currency</span>
                <div>{candidateDetails?.currency || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>Budget</span>
                <div>{candidateDetails?.budget || null}</div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>Budget UOM</span>
                <div>{candidateDetails?.budget_eom || null}</div>
              </Grid>
              {candidateDetails?.start_date && candidateDetails?.end_date ? (
                <>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px", fontWeight: 600 }}>Project Start Date</span>
                    <div>{candidateDetails.start_date}</div>
                  </Grid>
                  <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <span style={{ fontSize: "16px", fontWeight: 600 }}>Project End Date</span>
                    <div>{candidateDetails.end_date}</div>
                  </Grid>
                </>
              ) : null}
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>View Profile</span>
                <div>
                  <Button
                    variant="contained"
                    aria-haspopup="true"
                    disabled={isNonResume || !fileUrl}
                    style={{
                      background: isNonResume || !fileUrl ? "#ccc" : "#2777AA",
                      fontFamily: "Roboto, Helvetica, Arial, sans-serif"
                    }}
                    startIcon={<Visibility />}
                    onClick={() => {
                      if (!isNonResume && fileUrl) {
                        navigate("/candidate_data/viewFile", {
                          state: { fileUrl, from: "/candidate_data" },
                          replace: true
                        });
                      }
                    }}
                  >
                    View Profile
                  </Button>
                </div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>PAN Document</span>
                <div>
                  <Button
                    variant="contained"
                    aria-haspopup="true"
                    disabled={!panUrl}
                    style={{
                      background: !panUrl ? "#ccc" : "#2777AA",
                      fontFamily: "Roboto, Helvetica, Arial, sans-serif"
                    }}
                    startIcon={<Visibility />}
                    onClick={() => {
                      if (panUrl) {
                        navigate("/candidate_data/viewFile", {
                          state: { fileUrl: panUrl, from: "/candidate_data" },
                          replace: true
                        });
                      }
                    }}
                  >
                    View PAN
                  </Button>
                </div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>Aadhar Document</span>
                <div>
                  {candidateDetails?.aadhar_doc && !candidateDetails.aadhar_doc.includes('.') && !candidateDetails.aadhar_doc.includes('/') && !candidateDetails.aadhar_doc.includes('\\') && !candidateDetails.aadhar_doc.includes('http') && (
                    <div style={{ marginBottom: "4px" }}>
                      {candidateDetails.aadhar_doc}
                    </div>
                  )}
                  <Button
                    variant="contained"
                    aria-haspopup="true"
                    disabled={!aadharUrl}
                    style={{
                      background: !aadharUrl ? "#ccc" : "#2777AA",
                      fontFamily: "Roboto, Helvetica, Arial, sans-serif"
                    }}
                    startIcon={<Visibility />}
                    onClick={() => {
                      if (aadharUrl) {
                        navigate("/candidate_data/viewFile", {
                          state: { fileUrl: aadharUrl, from: "/candidate_data" },
                          replace: true
                        });
                      }
                    }}
                  >
                    View Aadhar
                  </Button>
                </div>
              </Grid>
              <Grid item xl={12} lg={12} md={12} xs={12}>
                <span style={{ fontSize: "16px", fontWeight: 600 }}>Notes (Optional)</span>
                <div style={{ wordBreak: "break-word", marginTop: "4px" }}>
                  {candidateDetails?.important_note || null}
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
  );
};

export default ViewCandidate;
